import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@lib/store/auth.store';
import { UserRole, esTelemarketer } from '@lib/types';
import { puedeVer, rutaInicial, type ViewKey } from '@lib/permissions/catalog';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  allowedRoles?: UserRole[];
  /**
   * Vista requerida (permiso). Si se pasa, gatea por el permiso EFECTIVO del
   * usuario (defaults del rol ⊕ overrides). Reemplaza a `allowedRoles` en las
   * rutas migradas; el fallback lleva a la primera vista que sí puede ver.
   */
  requiereVista?: ViewKey;
}

export function ProtectedRoute({ children, allowedRoles, requiereVista }: Props) {
  const { token, user } = useAuthStore();
  const location = useLocation();

  if (!token || !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // Gating por permiso de vista (preferido).
  if (requiereVista && !puedeVer(user, requiereVista)) {
    const destino = rutaInicial(user);
    return <Navigate to={destino === location.pathname ? '/busqueda' : destino} replace />;
  }

  // Compat: gating por rol para rutas no migradas.
  if (allowedRoles && !allowedRoles.includes(user.rol)) {
    const fallback = esTelemarketer(user.rol) ? '/busqueda' : '/dashboard';
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
